<template>
  <v-card tile class="mx-1">
    <v-card-text class="pa-5 mb-n12 pt-4">
      <router-link style="color: #536dfe !important;" class="primaryConst--text" :to="{ name: this.nivel.routeName, params: { projetoId: this.logicaIntervencao.projeto.id, logicaIntervencaoId: this.logicaIntervencao.id } }" >
        <p style="color: #536dfe !important;" class="mb-n1">{{ tituloPosicaoNivel }}</p>
        <p style="color: #536dfe !important;" class="text-h5">
          {{logicaIntervencao.descricao}}
        </p>
      </router-link>
    </v-card-text>

    <v-card-text class="pa-5">
      <p class="subtitle-1">
        <strong>Condições Prévias e Externas:</strong>
        {{
          logicaIntervencao.condicoesPreviasExternas
            ? logicaIntervencao.condicoesPreviasExternas
            : "Não se aplica."
        }}
      </p>
    </v-card-text>
    <v-card-actions class="pl-3 ml-n1 mt-n10">
      <LogicaIntervencaoEdit 
        v-if="isPermissao()"
        :titulo="tituloEdicao"
        :nivel="logicaIntervencao.nivel"
        :logicaIntervencao="{...logicaIntervencao}"
      ></LogicaIntervencaoEdit>

      <Confirm ref="confirm"></Confirm>
      <v-btn v-if="isPermissao()" :disabled="!logicaIntervencao.edicao" @click="excluir" color="error text-center" small>Excluir</v-btn>
      <v-switch v-if="isPermissao()" @change="ativarOuDesativarEdicao" class="ml-4 pb-n4" v-model="edicao" inset :label="`Edição ${edicao ? 'habilitada' : 'desabilitada'}`"></v-switch>

    </v-card-actions>
    <v-divider></v-divider>
  </v-card>

</template>

<script>
import LogicaIntervencaoEdit from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoEdit";
import Confirm from "@/components/Dialog/Confirm";
import {mapActions} from "vuex";

export default {
  components: {
    LogicaIntervencaoEdit,
    Confirm
  },
  props: {
    logicaIntervencao: {
      require: true,
    },
  },
  computed: {
    nivel() {
      return this.$store.getters["enums/nivel"][this.logicaIntervencao.nivel]
    },
    tituloPosicaoNivel() {
      return (this.logicaIntervencao.posicaoFormatada + " " + this.nivel.titulo);
    },
    tituloExcluir() {
      return ("Excluir " + this.nivel.titulo);
    },
    descricaoExcluir() {
      return (
        this.logicaIntervencao.posicaoFormatada + " " + this.logicaIntervencao.descricao
      );
    },
    tituloEdicao() {
      return "Editar " + this.nivel.titulo;
    },
    usuario() {
      return this.$store.getters["usuario/getUser"]
    }
  },
  data() {
    return {
      optionsExcluir: {
        color: 'primary',
        width: 400,
        zIndex: 200
      },
      edicao: this.logicaIntervencao.edicao
    };
  },
  methods: {
    ...mapActions('logicaIntervencao', ['excluirLogicaIntervencao', 'actionAivarOuDesativarEdicao']),
    ...mapActions('usuario', ['getUsuario']),

    excluir() {
      this.$refs.confirm.open(this.tituloExcluir, this.descricaoExcluir, 'Você tem certeza?', this.optionsExcluir).then((confirm) => {
        if (confirm) {
          const payload = {
            'projetoId': this.logicaIntervencao.projeto.id,
            'logicaIntervencaoId': this.logicaIntervencao.id
          }
          this.excluirLogicaIntervencao(payload)
        }
      })
    },
    ativarOuDesativarEdicao() {
      const payload = {
        'projetoId': this.logicaIntervencao.projeto.id,
        'logicaIntervencaoId': this.logicaIntervencao.id,
        'edicao': this.edicao
      }
      this.actionAivarOuDesativarEdicao(payload)
    },

    isPermissao() {
      //candEdit
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      var payload = {
        'permission': 'PERMISSION_LOGICA_INTERVERCAO_EDIT',
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }
      
      return this.$store.getters["projeto/hasPermission"](payload);
    },

  },
  created() {
    this.getUsuario()
  }
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: #536dfe !important;
  caret-color: #536dfe !important;
}
a:hover {
  text-decoration: underline !important;
  color: #536dfe !important;
  caret-color: #536dfe !important;
}
</style>